
import { BrowserModule, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule} from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { LoaderComponent } from './components/loader/loader.component';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { APP_BASE_HREF } from '@angular/common';
import { CustomUrlSerializer } from './utilities/CustomUrlSerializer';
import { UrlSerializer } from '@angular/router';
import { MatNativeDateModule, MAT_DATE_LOCALE, GestureConfig } from '@angular/material/core';
import { LoaderInterceptorService } from './services/loader-interceptor.service';
import { SharedServiceService } from './services/shared-service.service'
import { MatGridListModule } from '@angular/material/grid-list';
import { QdeModule } from './qde/qde.module';
import { TrackApplicationModule } from './track-application/track-application.module';
import { MatCarouselModule } from '@ngmodule/material-carousel';
import { AddonsModule } from './addons/addons.module';
import { CompleteApplicationModule } from './complete-application/complete-application.module';
import { ScheduleAppointmentModule } from './schedule-appointment/schedule-appointment.module';
import { CatalogueModule } from './catalogue/catalogue.module';
import { TrackAppPartnerModule } from './track-app-partner/track-app-partner.module';
export function getBaseUrl(): string {
  const currentPath = window.location.pathname;
  const pathArray = currentPath.split('/');
  const routesList = ['catalogue-partner','apply', 'qde', 'complete-application', 'data-capture', 'schedule-appointment', 'doc-upload', 'card-upgrade', 'card-tracking-and-delivery', 'track-app','track-app-status', '404', 'track-error','corporate-card', 'addon-card', 'success',
    'apply/card-upgrade-downgrade', 'apply/track-app', 'apply/track-app-status', 'track-application', 'track-application/track-error','track-application/corporate-card','skip-popup','error','card-decisioning','decisioning','catalogue-refer'];
  const proccessedPathArray = pathArray.filter(path => !routesList.includes(path));
  return proccessedPathArray.join('/');

}


@NgModule({
  declarations: [
    AppComponent,
    LoaderComponent,

  ], 
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatNativeDateModule,
    MatGridListModule,
    // MatTooltipModule
    //changes done for remove lazy loading
    QdeModule,
    TrackApplicationModule,
    TrackAppPartnerModule,
    AddonsModule,
    CompleteApplicationModule,
    ScheduleAppointmentModule,
    CatalogueModule,
    MatCarouselModule.forRoot(),
  ],
  providers: [
    { provide: APP_BASE_HREF, useFactory: getBaseUrl },
    // { provide: APP_BASE_HREF, useValue: window.location.pathname },
    { provide: UrlSerializer, useClass: CustomUrlSerializer },
    {provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
    { provide: HAMMER_GESTURE_CONFIG, useClass: GestureConfig },
    LoaderInterceptorService,
    SharedServiceService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
